// Admin readiness dashboard — operational "what needs to be done" report.
// Admin-only (backend gates on require_admin).
import { api } from "./client";

export type ReadinessStatus = "ready" | "action_needed" | "error" | "info";

export interface ReadinessItem {
  key: string;
  category: string;
  label: string;
  status: ReadinessStatus;
  detail: string;
  action: string | null;
}

export interface AdminReadinessResponse {
  items: ReadinessItem[];
  action_count: number;
  generated_at: string;
}

export function getReadiness(): Promise<AdminReadinessResponse> {
  return api.get<AdminReadinessResponse>("/admin/readiness");
}
